var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{staticClass:"imageCanvas",attrs:{"id":_vm.canvasid}})
}
var staticRenderFns = []

export { render, staticRenderFns }